"use client";
import { createPortal } from "react-dom";
import { LoaderCircle } from "lucide-react";


type LoaderWithMessageProps = {
    message: string|null;
  };
  
  function LoaderWithMessage({ message }: LoaderWithMessageProps) {
    return (
      <div className="fixed inset-0 z-[7000] flex items-center justify-center bg-white bg-opacity-95">
        <div className="flex flex-col items-center gap-4">
          <LoaderCircle className="w-16 h-16 animate-spin text-primary-700" />
          <p className="text-neutral-600 font-calibri font-normal text-base">
            {message}
          </p>
        </div>
      </div>
    );
  }
  
  export default LoaderWithMessage;
  
